import Template from './ConditionsAndPrivacy.hbs';
export default BaseView.extend({

    initialize() {
        // Parse template without params
        this.setElement(Template({}));
    }

});
